<form [formGroup]="formGroup">

    @if (!vraagAOWenANW) {
        <snelstart-ui-button (click)="showAOWenANW()" class="snelstart-ui-button" icon="plus"
                             type="link">Niet of deels verzekerd voor AOW en Anw
        </snelstart-ui-button>
    }

    @if (vraagAOWenANW) {

        <snelstart-ui-button (click)=" closeAOWenANW()" class="snelstart-ui-button" icon="minus"
                             type="link">Niet of deels verzekerd voor AOW en Anw
        </snelstart-ui-button>

        <div class="pt-2" formGroupName="periodeNietVerzekerdVoorAOWenANW">
            <snelstart-ui-date-form-control (change)="saveForm()"
                                            class="custom-input-250"
                                            formControlName="begindatum"
                                            id="begindatumAOW"
                                            label="Begindatum niet verzekerd AOW/ANW"
            >
            </snelstart-ui-date-form-control>
            <snelstart-ui-date-form-control (change)="saveForm()"
                                            class="custom-input-250"
                                            formControlName="einddatum"
                                            id="einddatumAOW"
                                            label="Einddatum niet verzekerd AOW/ANW"
            >
            </snelstart-ui-date-form-control>
        </div>
    }

    <div class="space20"></div>

    @if (!vraagWLZenZVW) {
        <snelstart-ui-button (click)="showWLZenZVW()" class="snelstart-ui-button" icon="plus"
                             type="link">Niet of deels verzekerd voor Wlz en Zvw
        </snelstart-ui-button>
    }

    @if (vraagWLZenZVW) {
        <snelstart-ui-button (click)=" closeWLZenZVW()" class="snelstart-ui-button" icon="minus"
                             type="link">Niet of deels verzekerd voor Wlz en Zvw
        </snelstart-ui-button>

        <div class="pt-2" formGroupName="periodeNietVerzekerdVoorWLZenWVZ">
            <snelstart-ui-date-form-control (change)="saveForm()"
                                            class="custom-input-250"
                                            formControlName="begindatum"
                                            id="begindatumWLZ"
                                            label="Begindatum niet verzekerd Wlz/Zvw"
            >
            </snelstart-ui-date-form-control>
            <snelstart-ui-date-form-control (change)="saveForm()"
                                            class="custom-input-250"
                                            formControlName="einddatum"
                                            id="einddatumWLZ"
                                            label="Einddatum niet verzekerd Wlz/Zvw"
            >
            </snelstart-ui-date-form-control>
        </div>
    }

    <div class="space20"></div>

    @if (!vraagVermindering) {
        <snelstart-ui-button (click)="showVermindering()" class="snelstart-ui-button" icon="plus"
                             type="link">Vermindering premie-inkomen
        </snelstart-ui-button>
    }

    @if (vraagVermindering) {

        <snelstart-ui-button (click)="closeVermindering()" class="snelstart-ui-button" icon="minus"
                             type="link">Vermindering premie-inkomen
        </snelstart-ui-button>

        <div class="col-auto row g-0 pt-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              align="right"
                                              class="custom-input-250 "
                                              formControlName="verminderingPremieInkomen"
                                              id="verminderingPremieInkomen"
                                              label="Vermindering premie-inkomen"
                                              prefix="€">
            </snelstart-ui-number-form-control>
            <span class="ps-3 pt-4 row col-auto"
                  snelstartUiTooltip="Ben je een deel van het aangiftejaar in Nederland verzekerd voor de volksverzekeringen?
                  Dan kan er sprake zijn van vermindering van het premie-inkomen. Lees ook de Toelichting."> &#x24D8;</span>
        </div>

    }

    <div class="space20"></div>

    @if (!vraagCorrectie) {
        <snelstart-ui-button (click)="showCorrectie()" class="snelstart-ui-button" icon="plus"
                             type="link">Correctie premie-inkomen
        </snelstart-ui-button>
    }

    @if (vraagCorrectie) {

        <snelstart-ui-button (click)="closeCorrectie()" class="snelstart-ui-button" icon="minus"
                             type="link">Correctie premie-inkomen
        </snelstart-ui-button>

        <div class="col-auto row g-0 pt-2">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              align="right"
                                              class="custom-input-250 "
                                              formControlName="correctiePremieInkomen"
                                              id="correctiePremieInkomen"
                                              label="Correctie premie-inkomen"
                                              prefix="€">
            </snelstart-ui-number-form-control>
            <span class="ps-3 pt-4 row col-auto"
                  snelstartUiTooltip="is er in Nederland sprake van verzekerd zijn voor de volksverzekeringen?
                  En zijn er ook buiten Nederland socialezekerheidspremies verschuldigd? Om te voorkomen dat
                  er dubbele premies betaalt worden, is er een aantal situaties waarbij een correctie
                  van het premie-inkomen plaatsvindt. Vul in dat geval hier het buitenlandse inkomen in
                   waarover buiten Nederland socialezekerheidspremies zijn geheven. Lees ook de Toelichting."> &#x24D8;</span>
        </div>
    }
</form>

@for (fout of datumFouten; track fout) {
    <div class="pt-3" style="width: 50%">
        <snelstart-ui-alert type="warning">Let op: {{ fout }}</snelstart-ui-alert>
    </div>
}









